export default "__VITE_ASSET__DRImYW0x__"